var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var AlignmentStateMachine = function (root, collectionToAlign) {
    var self = this;
    this.root = root;

    lib_core.StateMachine.call(this);

    var collection = collectionToAlign;

    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_LEFT_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_horizontal_left(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_CENTER_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_horizontal_center(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_HORIZONTAL_RIGHT_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_horizontal_right(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_VERTICAL_BOTTOM_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_vertical_bottom(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_VERTICAL_CENTER_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_vertical_center(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.ALIGNMENT_VERTICAL_TOP_BUTTON &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.alignCollection_vertical_top(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.DISTRIBUTE_HORIZONTAL &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.distributeCollection_horizontal(collection);
            self.root.stopRec();
        }
    );
    this.addEventAction("idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.DISTRIBUTE_VERTICAL &&
                    collection.size() > 0);
        },
        function(cEvent){
            self.root.rec();
            self.distributeCollection_vertical(collection);
            self.root.stopRec();
        }
    );
};
lib_core.inherit(AlignmentStateMachine, lib_core.StateMachine);

module.exports = AlignmentStateMachine;

AlignmentStateMachine.prototype._getCollectionBoundingbox = function (collection) {
    var boundingBox = null;
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var bb = element.data.boundingBox && element.data.boundingBox();
            if (bb) boundingBox = bb.merge(boundingBox);
        }
    });
    return boundingBox;
};

AlignmentStateMachine.prototype.alignCollection_horizontal_left = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = new lib_geometry.Coord(boundingBox.x, boundingBox.y);
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = new lib_geometry.Coord(elementBoundingBox.x, elementBoundingBox.y);
            var vec = goal.sub(cur);
            vec.y = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.alignCollection_horizontal_center = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = boundingBox.getCenter();
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = elementBoundingBox.getCenter();
            var vec = goal.sub(cur);
            vec.y = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.alignCollection_horizontal_right = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = new lib_geometry.Coord(boundingBox.x+boundingBox.width, boundingBox.y);
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = new lib_geometry.Coord(elementBoundingBox.x+elementBoundingBox.width, elementBoundingBox.y);
            var vec = goal.sub(cur);
            vec.y = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.alignCollection_vertical_bottom = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = new lib_geometry.Coord(boundingBox.x, boundingBox.y+boundingBox.height);
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = new lib_geometry.Coord(elementBoundingBox.x, elementBoundingBox.y+elementBoundingBox.height);
            var vec = goal.sub(cur);
            vec.x = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.alignCollection_vertical_center = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = boundingBox.getCenter();
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = elementBoundingBox.getCenter();
            var vec = goal.sub(cur);
            vec.x = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.alignCollection_vertical_top = function (collection) {
    var boundingBox = this._getCollectionBoundingbox(collection);
    var goal = new lib_geometry.Coord(boundingBox.x, boundingBox.y);
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var elementBoundingBox = element.data.boundingBox();
            var cur = new lib_geometry.Coord(elementBoundingBox.x+elementBoundingBox.width, elementBoundingBox.y);
            var vec = goal.sub(cur);
            vec.x = 0;
            element.move(vec);
        }
    });
};

AlignmentStateMachine.prototype.distributeCollection_horizontal = function (collection) {
    var elementPositionMap = new lib_core.Collections.HashMap();
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var pos = element.data.boundingBox().getCenter();
            elementPositionMap.put(element, pos);
        }
    });

    var sorted = [];
    collection.forEach(function(element) { sorted.push(element); });
    sorted.sort(function(a,b) { return elementPositionMap.get(a).x - elementPositionMap.get(b).x; });

    var lastElementPosition = elementPositionMap.get(sorted[sorted.length-1]);
    var firstElementPosition = elementPositionMap.get(sorted[0]);
    var startx = firstElementPosition.x;
    var inc = (lastElementPosition.x - startx)/(sorted.length-1);
    for(var i=1; i<sorted.length-1; i++) {
        var cur = elementPositionMap.get(sorted[i]);
        var goal = cur.copy();
        goal.x = startx + i*inc;
        var vec = goal.sub(cur);
        sorted[i].move(vec);
    }
};

AlignmentStateMachine.prototype.distributeCollection_vertical = function (collection) {
    var elementPositionMap = new lib_core.Collections.HashMap();
    collection.forEach(function(element) {
        if(element.data && element.data.boundingBox) {
            var pos = element.data.boundingBox().getCenter();
            elementPositionMap.put(element, pos);
        }
    });

    var sorted = [];
    collection.forEach(function(element) { sorted.push(element); });
    sorted.sort(function(a,b) { return elementPositionMap.get(a).y - elementPositionMap.get(b).y; });

    var lastElementPosition = elementPositionMap.get(sorted[sorted.length-1]);
    var firstElementPosition = elementPositionMap.get(sorted[0]);
    var starty = firstElementPosition.y;
    var inc = (lastElementPosition.y - starty)/(sorted.length-1);
    for(var i=1; i<sorted.length-1; i++) {
        var cur = elementPositionMap.get(sorted[i]);
        var goal = cur.copy();
        goal.y = starty + i*inc;
        var vec = goal.sub(cur);
        sorted[i].move(vec);
    }
};
